import { FilterState } from "../reducers/filter.reducer";


export type FilterAction = {
    type: string,

    //setShowFiltersRequest
    showFilters?: boolean,

    //applyFiltersRequest
    filters?: FilterState
}

export const
    SET_SHOW_FILTERS_REQUEST = "SET_SHOW_FILTERS_REQUEST",
    APPLY_FILTER = "APPLY_FILTER";

export function setShowFiltersRequest(showFilters: boolean): FilterAction {
    return {
        type: SET_SHOW_FILTERS_REQUEST,
        showFilters: showFilters
    };
}

export function applyFilter(filters: FilterState): FilterAction {
    return {
        type: APPLY_FILTER,
        filters: filters
    };
}